<template>
  <div></div>
</template>

<script>
import 'sweetalert2/dist/sweetalert2.min.css';
export default {
  name: 'Notification',
  data() {
    return {
      error: [],
      success: [],
      info: [],
    }
  },
  mounted() {
    this.error = this.$store.getters.error;
    this.success = this.$store.getters.success;
    this.info = this.$store.getters.info;
    this.$root.$on("alert_error", (alert) => {
      if (alert.length > 0 && alert[0].length > 0)
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: alert[0],
        });
    });
    this.$root.$on("alert_success", (alert) => {
      if (alert.length > 0 && alert[0].length > 0)
        this.$swal({
          icon: 'success',
          title: 'success',
          text: alert[0],
        });
    });
    this.$root.$on("alert_info", (alert) => {
      if (alert.length > 0 && alert[0].length > 0)
        this.$swal({
          icon: 'info',
          title: 'Info',
          text: alert[0],
        });
    });
  },
  created() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'setAlert') {
        if (mutation.payload.type === "error")
          this.error = mutation.payload.alert
        if (mutation.payload.type === "info")
          this.info = mutation.payload.alert;
        if (mutation.payload.type === "success")
          this.success = mutation.payload.alert;
      }
    });
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
